<template>
  <el-tooltip placement="top" content="ストーリーズトラッキング">
    <el-popover placement="bottom-start" trigger="click">
      <div class="flex-column" style="font-size:10px; width:180px">
        <div style="margin-bottom:8px; font-weight:700; font-size:11px" class="flex-row">
          <div class="new-tag small">NEW</div>
          <div>ストーリーズの自動取得</div>
        </div>
        <div>ストーリーズを数時間毎に自動で取得・保存します。保存されたストーリーズは投稿タブ内にて閲覧可能です。</div>
        <div class="divider full"></div>
        <div class="flex-row w-100">
          <el-tooltip placement="right" :disabled="collect_stories_limit_num > 0">
            <div class="activate-popover" slot="content">
              <div class="pointer" @click="toSetting">アップグレード</div>
              でご利用いただけます
            </div>
            <el-switch :disabled="!collect_stories_limit_num > 0" :value="stories" @change="stories ? Untracking() : changeStories()"></el-switch>
          </el-tooltip>
          <div v-if="stories" style="margin-left:5px; font-weight:700; color:#0095f6">ON</div>
          <div v-else style="margin-left:5px; color: #ccc">OFF</div>
          <div class="flex-space"></div>
          <div class="flex-row">
            <span>{{ new_tracking_num }}</span>
            <span>/{{ largerTrackingNumber }}</span>
            <el-tooltip>
              <div slot="content">ストーリーズは最大で{{ largerTrackingNumber }}人までトラッキング可能です。</div>
              <font-awesome-icon :icon="['fas', 'question-circle']" style="margin-left: 5px;" />
            </el-tooltip>
          </div>
        </div>
      </div>

      <div slot="reference" class="stories-button pointer" v-if="stories">
        <img src="../../assets/stories_blue.png" alt="" style="width:14px;" />
        <span class="stories-button-on">ON</span>
      </div>
      <div slot="reference" class="stories-button off pointer" v-else>
        <img src="../../assets/stories_black.png" alt="" style="width:14px;" />
        <span class="new-tag-button">NEW</span>
      </div>
    </el-popover>
  </el-tooltip>
</template>

<script>
const root = process.env.VUE_APP_API;
const changeStoriesTrackAPI = root + "/api/search/change_stories_track";

export default {
  name: "storiesButton",
  props: ["ig_id", "stories", "tracking_num", "activate"],
  data() {
    return {
      new_tracking_num: 0,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    max_tracking_number() {
      return this.$store.state.max_tracking_number;
    },
    collect_stories_limit_num() {
      return this.$store.state.service_plan.collect_stories_limit_num;
    },
    largerTrackingNumber() {  // max_tracking_number と collect_stories_limit_num の大きい方を返す
      return Math.max(this.$store.state.max_tracking_number, this.$store.state.service_plan.collect_stories_limit_num);
    }
  },
  mounted() {
    this.new_tracking_num = Number(this.tracking_num);
  },
  methods: {
    changeStories() {
      var params = new URLSearchParams();
      params.append("token", this.token);
      params.append("ig_id", this.ig_id);
      params.append("tracking", !this.stories);
      this.axios
        .post(changeStoriesTrackAPI, params)
        .then((response) => {
          if (response.data.status == "OK") {
            this.$emit("update:stories", !this.stories);
            this.$emit("storiesReactive");
            this.$nextTick(() => {
              if (this.stories == true) this.new_tracking_num += 1;
              else this.new_tracking_num -= 1;
            });
          } else {
            this.$message({
              message: response.data.message,
              type: "error",
              offset: 7,
            });
          }
        })
        .catch(() => {});
    },
    Untracking() {
      this.$alert("一度トラッキングを解除すると以前のストーリーズは閲覧できなくなります。", "ストーリーズトラッキングを解除", {
        showCancelButton: true,
        confirmButtonText: "解除",
        cancelButtonText: "キャンセル",
        type: "warning",
      }).then(() => {
        this.changeStories();
      }).catch(() => {
        // キャンセル時は何も表示しない
        return;
      });
    },
    toSetting() {
      this.$router.push("/setting");
    },
  },
};
</script>
